<template>
  <v-container>
    <v-row>
      <v-col>
        <span class="d-flex flex-row align-center">
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span class="d-flex flex-column">
            <h3>{{singular}} #{{ allData.id }}</h3>
            <h1 style="margin-top: -10px;">{{ allData.name }}</h1>
          </span>
          <v-btn class="mx-1" x-small fab color="info" @click="openEditEventDialog()"><v-icon>mdi-pencil</v-icon></v-btn>
          <v-btn class="mx-1" x-small fab color="error" @click="openDeleteDialog()"><v-icon>mdi-delete</v-icon></v-btn>
        </span>
        <v-card outlined>
          <v-card-text>
            <span class="d-flex flex-row align-center">
              <h4>Unique Item List (UIL)</h4>
              <v-btn class="mx-1" x-small fab color="success" @click="openAddEventItemDialog()"><v-icon>mdi-plus</v-icon></v-btn>
            </span>
            <span>
              <v-text-field
                v-model="eventItemSearch"
                append-icon="mdi-magnify"
                label="Search"
                clearable
                single-line
                hide-details
              ></v-text-field>
            </span>
            <v-data-table
              :items="allData.eventItemJoins"
              :headers="eventItemHeaders"
              :search="eventItemSearch"
              dense
              :items-per-page="-1"
            >
              <template v-slot:item.remove="{ item }">
                <v-btn icon @click="openRemoveItemDialog(item)"><v-icon>mdi-close</v-icon></v-btn>
              </template>
              <!-- <template v-slot:item.item="{ item }">
                <span>{{ item.Item.Asset.styleNo+(item.Item.colour?` (${item.Item.colour})`:'') }}</span>
              </template> -->
            </v-data-table>           
          </v-card-text>
        </v-card>
<!--        <v-card class="mt-2" outlined>-->
<!--          <v-card-text>-->
<!--            <h4>Jobs</h4>-->
<!--            <v-data-table-->
<!--                :items="allData.Jobs"-->
<!--                :headers="jobHeaders"-->
<!--                @click:row="viewJobRow"-->
<!--                dense-->
<!--                :items-per-page="-1"-->
<!--            >-->
<!--              <template v-slot:item.customer="{ item }">-->
<!--                <span v-if="item.Item && item.Item.Customer">{{ item.Item.Customer.firstName+' '+item.Item.Customer.lastName }}</span>-->
<!--              </template>-->
<!--              <template v-slot:item.dateOut="{ item }">-->
<!--                <span>{{ momentDateFormat(item.dateOut) }}</span>-->
<!--              </template>-->
<!--              <template v-slot:item.dateIn="{ item }">-->
<!--                <span>{{ momentDateFormat(item.dateIn) }}</span>-->
<!--              </template>-->
<!--              <template v-slot:item.item="{ item }">-->
<!--                <span>{{ item.Item.Asset.styleNo+(item.Item.colour?` (${item.Item.colour})`:'') }}</span>-->
<!--              </template>-->
<!--              <template v-slot:item.tailor="{ item }">-->
<!--                <span>{{ item.Tailor?item.Tailor.name:"None" }}</span>-->
<!--              </template>-->
<!--              <template v-slot:item.status="{ item }">-->
<!--                <span>{{ parseJobStatus(item.status) }}</span>-->
<!--              </template>-->
<!--            </v-data-table>-->
<!--          </v-card-text>-->
<!--        </v-card>-->
      </v-col>
    </v-row>

    <v-dialog scrollable v-model="removeItemDialog.isOpen" max-width="400">
      <v-card class="align-center">
        <v-card-title>
          Remove Item Dialog
        </v-card-title>
        <v-card-text class="pa-5 text-center">
          <span>Are you sure you want to remove this UIL Item?</span>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" text @click="closeRemoveItemDialog">
            Cancel
          </v-btn>
          <v-btn color="success" @click="removeItem(removeItemDialog.data)" :loading="removeItemDialog.isLoading">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="createAssetDialog.isOpen" max-width="600">
      <v-card>
        <v-card-title>
          Create New Asset (Default Item)
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="createAssetDialog.validCreateAsset">
            <v-text-field
                label="Style No."
                outlined
                :rules="rules.required"
                v-model="createAssetDialog.data.styleNo"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateAsset">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!createAssetDialog.validCreateAsset" @click="createAsset(assetUsage)" :loading="createAssetDialog.isLoading">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="addEventItemDialog.isOpen" max-width="600">
      <v-card>
        <v-card-title>
          Add Unique Item List (UIL)
        </v-card-title>
        <v-card-text class="pa-5">
          <span class="d-flex flex-row">
            <v-autocomplete
              :items="customers"
              :item-text="x => x.fullName + (x.phone?' | '+x.phone:'') + (x.email?' | '+x.email:'')"
              item-value="id"
              label="Customer"
              dense
              outlined
              clearable
              @change="createdCustomerChanged"
              :rules="rules.required"
              v-model="addEventItemDialog.data.customerId"
          />
          <v-btn class="ml-1 mr-2" @click="showCreateCustomerDialog('create')" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
          </span>
          <span class="d-flex flex-column">
            <span class="d-flex flex-row">
              <v-autocomplete
                  :items="addEventItemDialog.data.items"
                  item-text="name"
                  return-object
                  :label="addEventItemDialog.data.customerId?'Item':'Select a customer first...'"
                  outlined
                  dense
                  clearable
                  hint="Item"
                  :persistent-hint="addEventItemDialog.data.customerId==null"
                  :loading="addEventItemDialog.isLoadingItems"
                  :disabled="!addEventItemDialog.data.customerId"
                  :rules="rules.required"
                  v-model="addEventItemDialog.data.item"
              />
              <v-btn class="ml-1" @click="openCreateAssetDialog('create')" :disabled="!addEventItemDialog.data.customerId" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
              <v-text-field class="ml-2" outlined dense v-if="addEventItemDialog.data && addEventItemDialog.data.item && addEventItemDialog.data.item.type==='asset'" label="Colour" v-model="addEventItemDialog.data.item.colour"/>
            </span>
          </span>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeAddEventItemDialog">Cancel</v-btn>
          <v-btn color="success" @click="addEventItem" :disabled="!addEventItemDialog.data.item || !addEventItemDialog.data.customerId" :loading="addEventItemDialog.isLoading">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="editEventDialog" max-width="600">
      <v-card>
        <v-card-title>
          Edit {{singular}}
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="validEditEvent">
            <span class="d-flex flex-row">
                <v-autocomplete
                    :items="customers"
                    :item-text="x => x.firstName + ' ' + x.lastName + (x.phone?' | '+x.phone:'') + (x.email?' | '+x.email:'')"
                    item-value="id"
                    label="Customer"
                    outlined
                    clearable
                    v-model="editEvent.customerId"
                />
                <v-btn @click="showCreateCustomerDialog('edit')" class="mt-2 ml-2" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
              </span>
            <span>
                <v-text-field
                    label="Event Name"
                    outlined
                    v-model="editEvent.name"
                />
              </span>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeEditEventDialog">Cancel</v-btn>
          <v-btn color="success" :disabled="!validEditEvent" @click="updateEvent" :loading="editLoading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="createCustomerDialog" max-width="600">
      <v-card>
        <v-card-title>
          Create Customer
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="validCreateCustomer">
            <v-text-field
                label="First Name"
                outlined
                :rules="rules.required"
                v-model="newCustomer.firstName"
                @input="existingData=null"
            />
            <v-text-field
                label="Last Name"
                outlined
                :rules="rules.required"
                v-model="newCustomer.lastName"
                @input="existingData=null"
            />
            <v-text-field
                label="Phone"
                outlined
                v-model="newCustomer.phone"
                @input="existingData=null"
            />
            <v-text-field
                label="Email"
                outlined
                v-model="newCustomer.email"
                @input="existingData=null"
            />
            <span>
              <h3>Address</h3>
              <v-text-field
                  label="Address Line 1"
                  outlined
                  v-model="newCustomer.address.line1"
                  @input="existingData=null"
              />
              <v-text-field
                  label="Address Line 2"
                  outlined
                  v-model="newCustomer.address.line2"
                  @input="existingData=null"
              />
              <v-text-field
                  label="City"
                  outlined
                  v-model="newCustomer.address.city"
                  @input="existingData=null"
              />
              <v-text-field
                  label="Notes"
                  outlined
                  v-model="newCustomer.notes"
                  @input="existingData=null"
              />
            </span>
          </v-form>
          <div v-if="existingData">
            <p class="red--text">A Customer with this information already exists. Are you sure you want to create another?</p>
            <h3>Or choose the existing Customer</h3>
            <v-btn color="info" @click="existingCustomerSelected">{{existingData.firstName}} {{existingData.lastName}}</v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateCustomer">
            Cancel
          </v-btn>
          <v-btn color="success" v-if="!existingData" :disabled="!validCreateCustomer" @click="createCustomer" :loading="customerLoading">Create</v-btn>
          <v-btn v-else color="success" :disabled="!validCreateCustomer" @click="confirmCreateCustomer" :loading="customerLoading">Create New</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="confirmDeleteDialog" max-width="400">
      <v-card class="align-center">
        <v-card-title>
          Delete {{singular}}
        </v-card-title>
        <v-card-text class="pa-5 text-center">
          <span>Are you sure you want to delete this {{singularLower}}?</span>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" text @click="closeDeleteDialog">
            Cancel
          </v-btn>
          <v-btn color="success" @click="deleteEvent" :loading="deleteLoading">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </v-container>
</template>
<script>
import axios from 'axios';
import moment from "moment";
import {mapGetters} from "vuex";
export default {
  data () {
    return {
      isEditable: false,
      eventItemSearch: '',
      snackObj: {
        color: '',
        text: ''
      },
      createAssetDialog: {
        isOpen: false,
        isLoading: false,
        usage: 'create',
        validCreateAsset: false,
        data: {}
      },
      removeItemDialog: {
        isOpen: false,
        isLoading: false,
        data: {}
      },
      addEventItemDialog: {
        isOpen: false,
        isLoading: false,
        isLoadingItems: false,
        isAsset: false,
        data: {}
      },
      search: "",

      rules: {
        required: [v => !!v || 'This field is required.'],
      },
      validCreate: false,
      validUpdate: false,
      validCreateCustomer: false,
      validEditEvent: false,

      loader: false,
      assets: [],
      allData: [],
      formData: {},
      searchedData: [],

      jobHeaders: [
        { text: 'ID', align: 'start', sortable: true, value: 'id' },
        { text: 'Customer', sortable: true, value: 'customer' },
        { text: 'Date Out', sortable: true, value: 'dateOut' },
        { text: 'Date In', sortable: true, value: 'dateIn' },
        { text: 'Item', sortable: true, value: 'item' },
        { text: 'Tailor', sortable: true, value: 'tailor' },
        { text: 'Status', sortable: true, value: 'status' },
      ],
      
      eventItemHeaders: [
        { text: 'Customer', sortable: true, value: 'customer' },
        { text: 'Item', sortable: true, value: 'item' },
        { text: 'Remove', sortable: true, value: 'remove' },
      ],

      formLoader: false,
      deleteLoading: false,
      confirmDeleteDialog: false,

      editEvent: {},
      editLoading: false,
      editEventDialog: false,

      selectedRow: null,
      showAddNew: false,
      showSelected: false,

      customers: [],
      createCustomerDialog: false,
      newCustomer: {address: {}},
      customerLoading: false,
      customerDialogType: null,

      existingData: null,

      pluralLower: "events",
      plural: "Events",
      singularLower: "event",
      singular: "Event"
    }
  },
  async mounted(){
    await this.getAllData();
  },
  computed: {
    ...mapGetters(['getEndpoint'])
  },
  methods: {
    openRemoveItemDialog(item){
      this.removeItemDialog.isOpen = true;
      this.removeItemDialog.data = item
    },
    closeRemoveItemDialog(){
      this.removeItemDialog = {
        isOpen: false,
        isLoading: false,
        data: {}
      }
    },
    async removeItem(item){
      try{
        this.removeItemDialog.isLoading = true;

        let res = await axios.delete(`${this.getEndpoint}/api/events/item/${item.id}`)
        if(res.data.error) throw res.data.error;

        this.snack("Item Deleted.")
        this.getAllData()

        this.closeRemoveItemDialog();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.removeItemDialog.isLoading = false;
        this.removeItemDialog.isOpen = false;
      }
    },
    openCreateAssetDialog(usage="create"){
      this.createAssetDialog.isOpen = true;
      this.assetUsage = usage;
    },
    closeCreateAsset(){
      this.createAssetDialog = {
        isOpen: false,
        isLoading: false,
        usage: 'create',
        validCreateAsset: false,
        isAsset: false,
        data: {}
      }
    },
    async createAsset(usage="create"){
      try{
        this.createAssetDialog.isLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/assets`, this.createAssetDialog.data)
        if(res.data.error) throw res.data.error;

        if(usage==="create"){
          this.allData.item = {
            id: res.data.data.data.id,
            name: res.data.data.data.styleNo,
            type: "asset",
            itemId: null,
            assetId: res.data.data.data.id
          }
        }
        else if(usage==="update"){
          this.allData.customItem = {
            id: res.data.data.data.id,
            name: res.data.data.data.styleNo,
            type: "asset",
            itemId: null,
            assetId: res.data.data.data.id
          }
        }
        else{
          throw "Invalid item usage."
        }

        if(res.data.data.created){
          this.snack(`Asset Created 🎉`);

          res = await axios.get(`${this.getEndpoint}/api/assets`)
          if(res.data.error) throw res.data.error;
          this.assets = res.data.data;

          if(usage==="create"){
            await this.updateItems();
          }
          else if(usage==="update"){
            await this.updateSelectedItems();
          }
        }
        else{
          this.snack(`Asset already exists. Adding to form...`);
        }

        this.closeCreateAsset();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.createAssetDialog.isLoading = false;
        this.createAssetDialog.isOpen = false;
      }
    },
    async openAddEventItemDialog(){
      try {
        this.addEventItemDialog.isOpen = true
        let res = await axios.get(`${this.getEndpoint}/api/customers`)
        if(res.data.error) throw res.data.error;
        
        this.customers = res.data.data;
      } catch (error) {
        console.log(error)
      }
    },
    closeAddEventItemDialog(){
      this.addEventItemDialog = {
        isOpen: false,
        isLoading: false,
        isLoadingItems: false,
        data: {}
      }
    },
    async addEventItem(){
      try {
        this.addEventItemDialog.isLoading = true

        if(!this.addEventItemDialog.data) return
        if(!this.addEventItemDialog.data.item) return

        console.log(this.addEventItemDialog.data)
        let obj = this.addEventItemDialog.data
        
        delete obj.items
        obj.eventId = this.allData.id
        
        console.log(obj)
        let res = await axios.post(`${this.getEndpoint}/api/events/item`, obj)
        if(res.data.error) throw res.data.error;

        this.snack(`Unique Event Item Created 🎉`);
        this.closeAddEventItemDialog()
        this.getAllData()

      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.addEventItemDialog.isLoading = false
      }
    },
    createdCustomerChanged(){
      if(this.addEventItemDialog.data.itemId){
        this.addEventItemDialog.data.itemId = null
      }
      if(this.addEventItemDialog.data.item){
        this.addEventItemDialog.data.item = null
      }
      this.updateItems()
    },
    async updateItems(){
      try{
        this.addEventItemDialog.isLoadingItems = true;

        let initItems = [];

        if(this.addEventItemDialog?.data.customerId){
          let res = await axios.get(`${this.getEndpoint}/api/items/byCustomer/${this.addEventItemDialog?.data.customerId}`)
          if(res.data.error) throw res.data.error;

          let customerItems = res.data.data;

          initItems.push({disabled:true, name: "-----Customer Items-----"})
          if(customerItems.length===0){
            initItems.push({disabled:true, name: "None"})
          }
          else{
            for(let item of customerItems){
              let name = '';
              name+=item.Asset.styleNo;
              if(item.colour && item.colour.length>0){
                name+=" ("+item.colour+")"
              }

              let obj = {
                name: name,
                id: item.id,
                type: "item"
              };
              initItems.push(obj);
            }
          }
        }
        else{
          this.addEventItemDialog.data.itemId = null;
        }

        initItems.push({disabled:true, name: "-----Default Items-----"})
        if(this.assets.length===0){
          initItems.push({disabled:true, name: "None"})
        }
        else{
          for(let asset of this.assets){
            let obj = {
              name: asset.styleNo,
              id: asset.id,
              type: "asset"
            };
            initItems.push(obj);
          }
        }

        this.addEventItemDialog.data.items = initItems;
        console.log('New items done')
      }
      catch (e) {
        console.error(e);
        this.snack(e.msg || e, "error");
      }
      finally {
        this.addEventItemDialog.isLoadingItems = false;
      }
    },
    viewJobRow(row){
      this.$router.push(`/jobs?selected=${row.id}`)
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
    parseDate(date){
      if(!date) return null;
      return moment(this.parseISODate(date)).format("DD/MM/YYYY")
    },
    momentDateFormat (date) {
      return date ? moment(this.parseISODate(date)).format('ddd, MMM Do YYYY') : '';
    },
    parseISODate(date){
      return (date?new Date(date).toISOString().substring(0, 10):null);
    },
    parseJobStatus(id){
      if(id===-1) return "Voided"
      else if(id===0) return "New"
      else if(id===1) return "Sent"
      else if(id===2) return "Received"
      else if(id===3) return "Completed"
    },
    async closeMenu(){
      this.showSelected = false;
      this.showAddNew = false;
      if(this.$route.query.selected){
        await this.$router.replace({path: `/${this.pluralLower}`, query: null})
      }
    },
    async showCreateMenu(){
      if(!(this.$route.query.create)){
        await this.$router.replace({path: `/${this.pluralLower}`, query: {create: "true"}})
      }

      this.formData = {
        deliveryInfo: {
          address: {}
        }
      };

      this.showSelected = false;
      this.showAddNew = true;
    },
    async create(){
      try {
        let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.formData)
        if(res.data.error) throw res.data.error;

        this.snack(`${this.singular} Created 🎉`);

        await this.$router.push(`/${this.pluralLower}/view/${res.data.data.id}`)
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
    },
    async updateEvent(){
      try {
        this.editLoading = true;
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.editEvent.id}`, this.editEvent)
        if(res.data.error) throw res.data.error;

        this.snack(`${this.singular} Updated 🎉`);

        this.getAllData()

        this.closeEditEventDialog();
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.editLoading = false;
      }
    },
    openEditEventDialog(){
      this.editEvent = {
        id: this.allData.id,
        customerId: this.allData?.customerId,
        name: this.allData.name
      };

      this.editEventDialog = true;
    },
    closeEditEventDialog(){
      this.editEvent = {};
      this.editEventDialog = false;
      this.eventLoading = false;
    },
    async deleteEvent(){
      try {
        if(!this.currentDelete) throw "Invalid Event to delete."
        this.deleteLoading = true
        let res = await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.currentDelete}`)
        if(res.data.error) throw res.data.error
        this.snack(`${this.singular} Deleted 🎉`);

        this.closeDeleteDialog();
        await this.closeMenu();
        await this.getAllData();

      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
    },
    openDeleteDialog(){
      this.currentDelete = this.allData.id;
      this.confirmDeleteDialog = true;
    },
    closeDeleteDialog(){
      this.currentDelete = null;
      this.confirmDeleteDialog = false;
      this.deleteLoading = false;
    },
    async getAllData(){
      try {
        this.loader = true;
        let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
        if(res.data.error) throw res.data.error;
        
        for(let i of res.data.data.eventItemJoins){
          if(i.Item){
            if(i.Item.Customer){
              i.customer = i.Item.Customer.firstName + " " + i.Item.Customer.lastName + " | " + i.Item.Customer.phone 
            }
            if(i.Item.Asset){
              i.item = i.Item.Asset.styleNo+(i.Item.colour?` (${i.Item.colour})`:'') 
            }
          }
        }
        
        this.allData = res.data.data
        this.searchedData = this.allData;

        res = await axios.get(`${this.getEndpoint}/api/assets`)
        if(res.data.error) throw res.data.error;
        this.assets = res.data.data;

        // res = await axios.get(`${this.getEndpoint}/api/customers`)
        // if(res.data.error) throw res.data.error;
        // this.customers = res.data.data;

        // if(!this.$route.query.selected && this.allData.length>0){
        //   await this.$router.replace({path: `/${this.pluralLower}`, query: {selected: this.allData[0].id}})
        // }

        // if(this.$route.query && this.$route.query.create){
        //   await this.showCreateMenu();
        //   if(this.$route.query.customer){
        //     this.formData.customerId = this.customers.find(x => x.id===parseInt(this.$route.query.customer));
        //   }
        // }

        // if(this.$route.query && this.$route.query.selected){
        //   this.selectedRow = this.allData.find(x => x.id===parseInt(this.$route.query.selected));
        //   if(this.selectedRow){
        //     this.showAddNew = false;
        //     this.showSelected = true;
        //   }
        // }

      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.loader = false;
      }
    },
    queryEvents(){
      if(this.search.length===0){
        this.searchedData = this.allData;
        return;
      }

      let results = [];

      for(let row of this.allData){
        if(row.name.toLowerCase().includes(this.search.toLowerCase()) ||
            row.Customer?(row.Customer.firstName.toLowerCase().includes(this.search.toLowerCase()) ||
            row.Customer.lastName.toLowerCase().includes(this.search.toLowerCase()) ||
            (row.Customer.phone?row.Customer.phone.toLowerCase().includes(this.search.toLowerCase()):false) ||
            (row.Customer.email?row.Customer.email.toLowerCase().includes(this.search.toLowerCase()):false)):false){
          results.push(row);
          continue;
        }

        for(let job of row.Jobs){
          if(job.id==this.search || ((job.Item && job.Item.Customer)?(job.Item.Customer.firstName.toLowerCase().includes(this.search.toLowerCase()) ||
              job.Item.Customer.lastName.toLowerCase().includes(this.search.toLowerCase())):false) ||
              (job.dateOut?this.momentDateFormat(job.dateOut).includes(this.search.toLowerCase()):false) ||
              (job.dateIn?this.momentDateFormat(job.dateIn).includes(this.search.toLowerCase()):false) ||
              (job.status!==undefined?this.parseJobStatus(job.status).toLowerCase().includes(this.search.toLowerCase()):false) ||
              ((job.Item && job.Item.Asset)?(job.Item.Asset.styleNo+(job.Item.colour?` (${job.Item.colour})`:'')).toLowerCase().includes(this.search.toLowerCase()):false) ||
              (job.Tailor?job.Tailor.name:"None").toLowerCase().includes(this.search.toLowerCase())){
            results.push(row);
            break;
          }
        }

        this.searchedData = results;

      }
    },
    showCreateCustomerDialog(type){
      this.createCustomerDialog = true;
      this.customerDialogType = type;
    },
    existingCustomerSelected(){
      if(this.customerDialogType === 'new'){
        this.formData.customerId = this.existingData.id;
      }
      else if(this.customerDialogType === 'edit'){
        this.editEvent.customerId = this.existingData.id;
      }
      this.closeCreateCustomer();
    },
    closeCreateCustomer(){
      this.customerDialogType = null;
      this.createCustomerDialog = false;
      this.newCustomer = {address: {}};
      this.existingData = null;
      this.customerLoading = false;
    },
    async createCustomer(){
      try{
        this.customerLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/customers`, this.newCustomer)
        if(res.data.error) throw res.data.error;

        let newC = res.data.data;

        
        if(newC.existing){
          this.existingData = newC;
          this.snack("Customer with this phone number already exists.")
          return;
        }

        res = await axios.get(`${this.getEndpoint}/api/customers`)
        if(res.data.error) throw res.data.error;
        this.customers = res.data.data;

        this.addEventItemDialog.data.customerId = newC.id;
        
        this.createdCustomerChanged()

        this.closeCreateCustomer();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.customerLoading = false;
      }
    },
    async confirmCreateCustomer(){
      try{
        this.customerLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/customers/force`, this.newCustomer)
        if(res.data.error) throw res.data.error;

        let newC = res.data.data;

        res = await axios.get(`${this.getEndpoint}/api/customers`)
        if(res.data.error) throw res.data.error;
        this.customers = res.data.data;

        if(this.customerDialogType === 'new'){
          this.formData.customerId = newC;
        }
        else if(this.customerDialogType === 'edit'){
          this.editEvent.customerId = newC;
        }
        this.snack("Customer Created!", "success")
        this.closeCreateCustomer();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.customerLoading = false;
      }
    },
  }
}
</script>
